import { MenuItem } from '@/root/shared-types'

export const getMenuItemsByLine = (items: MenuItem[] = [], desiredLine: number) =>
  items.filter(({ line }) => desiredLine === line)
